export const TRANSFER_FILTER_TITLES = {
    ALL: {
        title: 'Все',
        value: `all-transfer`,
        checked: true,
        count: `all`
    },
    NOT_TRANSFER: {
        title: 'Без пересадок',
        value: `not-transfer`,
        count: 0
    },
    ONE_TRANSFER: {
        title: '1 пересадка',
        value: `one-transfer`,
        count: 1
    },
    TWO_TRANSFER: {
        title: '2 пересадки',
        value: `two-transfer`,
        count: 2
    },
    THREE_TRANSFER: {
        title: '3 пересадки',
        value: `three-transfer`,
        count: 3
    },
};

export const SORT_TYPE = {
    CHEAPER: `cheaper`,
    FASTER: `faster`
};
